/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/news/:id(\d+)'>.
 * Regex-параметр :id(\d+) эмулируется numericIdShell: не-число → 404.
 */
import { createFileRoute, notFound } from '@tanstack/react-router';
import { numericIdShell } from '../compat/shells';
import NewsSingle from '@routes/NewsSingle';
import { getQueryClient } from '../../providers/query';
import { singleNewsQueryOptions } from '@queries/index';
import { isContentNotFoundError } from '../../api/contentNotFound';

export const Route = createFileRoute('/news/$id')({
  /**
   * ЭТАП 2 — честный 404 несуществующей новости: бэк (newsResolver
   * .findNewsById) кидает CONTENT_NOT_FOUND -> notFound() -> HTTP 404 +
   * контент /404 без редиректа. Как у товара: лоадеры TanStack параллельны
   * root-префетчу -> await ensureQueryData (дедуп по ключу, серверный клиент
   * с retry:false). Не-числовой id — 404 сразу (numericIdShell рендерил
   * контент со статусом 200). Клиентскую навигацию не блокируем.
   */
  loader: async ({ params }) => {
    if (!/^\d+$/.test(params.id)) {
      throw notFound();
    }
    if (typeof window !== 'undefined') {
      return;
    }
    const queryClient = getQueryClient();
    const options = singleNewsQueryOptions(Number(params.id));
    // Префетч успел упасть раньше — ошибка уже в кэше, без второго запроса
    const settled = queryClient.getQueryState(options.queryKey);
    if (settled?.error) {
      if (isContentNotFoundError(settled.error)) {
        throw notFound();
      }
      return;
    }
    try {
      await queryClient.ensureQueryData(options);
    } catch (error) {
      if (isContentNotFoundError(error)) {
        throw notFound();
      }
    }
  },
  component: numericIdShell(NewsSingle, '/news/:id(\\d+)')
});
